
 <router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/error' || location == '/payment-gateway' || location == '/login' || location == '/register')"></app-footer>
